'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetAvailabilityOptions = undefined;

var _reselect = require('reselect');

var _getWidgetData = require('../../selectors/widgetDataSelectors/getWidgetData');

var _getAvailabilityOptions = require('../operators/getAvailabilityOptions');

var getWidgetAvailabilityOptions = exports.getWidgetAvailabilityOptions = (0, _reselect.createSelector)([_getWidgetData.getWidgetData], _getAvailabilityOptions.getAvailabilityOptions);


//////////////////
// WEBPACK FOOTER
// ./js/availability/selectors/getWidgetAvailabilityOptions.js
// module id = 97
// module chunks = 2 3